"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var selfUtil = _interopRequireWildcard(require("@/utils/ZBKJIutil.js"));
var _vuex = require("vuex");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'creatPro',
  data: function data() {
    return {
      options: [{
        value: 1,
        label: '一口价'
      }, {
        value: 2,
        label: '价格区间（左边不能大于右边）'
      }, {
        value: 3,
        label: '折扣价（左边为原价，右边为现价）'
      }],
      form: {
        // coverImgUrl: '',
        // name: '',
        // price: '',
        // priceType: '',
      },
      multipleSelection: [],
      proData: [],
      listLoading: false,
      loading: false,
      keyNum: 0,
      isShowCheck: false,
      attrValue: [],
      //普通商品sku数组
      productId: 0,
      //普通商品id
      multipleSelectionAll: []
    };
  },
  mounted: function mounted() {
    if (this.$route.params.liveId !== '0') {
      this.getInfo();
    }
  },
  computed: {
    //判断是否是编辑
    isEdit: function isEdit() {
      return this.$route.params.liveId !== '0' ? true : false;
    }
  },
  methods: {
    //价格名称
    keyupEvent: function keyupEvent(i, key) {
      this.proData[i].name = key.substring(0, 14);
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i, status) {
      var _this = this;
      if (_this.isDisabled) return;
      this.$modalUpload(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(img) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (img) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                if (!(!tit && num === 'duo')) {
                  _context.n = 3;
                  break;
                }
                _this.proData[i].image = img[0].sattDir;
                _context.n = 2;
                return _this.getImgData(img[0].sattDir);
              case 2:
                _this.proData[i].coverImgUrl = _context.v;
              case 3:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), tit, 'content');
    },
    //选择
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;
      this.multipleSelectionAll = val;
      this.multipleSelectionAll.forEach(function (item) {
        _this2.$set(item, 'checked', true);
      });
      // this.$set(row, 'checked', val);
      if (val.length > 0) {
        this.isShowCheck = false;
      } else {
        this.isShowCheck = true;
      }
    },
    //详情
    getInfo: function getInfo() {
      var _this3 = this;
      this.listLoading = true;
      (0, _marketing.liveGoodsInfoApi)(this.$route.params.liveId).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (res) {
                  _this3.proData = [res];
                  _this3.proData.map(function (item) {
                    _this3.$set(item, 'image', res.coverImgUrlLocal);
                    _this3.$set(item, 'price', Number(res.price));
                    _this3.$set(item, 'price2', Number(res.price2));
                    _this3.$set(item, 'price3', Number(res.price3));
                  });
                }
                _this3.listLoading = false;
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this3.listLoading = false;
      });
    },
    back: function back() {
      this.$router.push({
        path: "/marketing/broadcast/product"
      });
    },
    //行删除
    handleDelete: function handleDelete(index, row) {
      var _this4 = this;
      this.$modalSure('删除该直播商品吗？').then(function () {
        var i = _this4.proData.findIndex(function (item) {
          return item == row;
        });
        _this4.proData.splice(i, 1);
      });
    },
    batchDel: function batchDel() {
      var _this5 = this;
      this.$modalSure("\u6279\u91CF\u5220\u9664\u76F4\u64AD\u5546\u54C1\u5417\uFF1F").then(function () {
        _this5.proData.forEach(function (itemA, indexA) {
          _this5.multipleSelectionAll.forEach(function (itemB) {
            if (itemA.id === itemB.id) {
              _this5.proData.splice(indexA, 1);
            }
          });
        });
        _this5.proData = _this5.proData.filter(function (item) {
          return !item.checked;
        });
      });
    },
    //添加商品
    addGoods: function addGoods() {
      var _this = this;
      this.$modalGoodList(function (row) {
        var _this6 = this;
        _this.listLoading = false;
        row.map(function (item) {
          _this6.$set(item, 'priceType', 1);
          _this6.$set(item, 'name', item.name.substring(0, 14));
        });
        _this.proData = row;
        _this.getShopImgUpload(row);
      }, 'many', _this.proData, Number(_this.form.id));
    },
    // 获取微信mediaId码
    getShopImgUpload: function () {
      var _getShopImgUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(attrs) {
        var key, _t, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _t = _regeneratorKeys(attrs);
            case 1:
              if ((_t2 = _t()).done) {
                _context3.n = 3;
                break;
              }
              key = _t2.value;
              _context3.n = 2;
              return this.getImgData(attrs[key].image);
            case 2:
              attrs[key].coverImgUrl = _context3.v;
              _context3.n = 1;
              break;
            case 3:
              return _context3.a(2, attrs);
          }
        }, _callee3, this);
      }));
      function getShopImgUpload(_x3) {
        return _getShopImgUpload.apply(this, arguments);
      }
      return getShopImgUpload;
    }(),
    // 传入图片地址调接口，获取到微信mediaId码
    getImgData: function getImgData(file) {
      var _this7 = this;
      this.listLoading = true;
      return new Promise(function (resolve, reject) {
        (0, _marketing.liveMediaUploadlocalApi)({
          imagePath: file,
          type: 'image'
        }).then(function (res) {
          resolve(res.mediaId);
          _this7.listLoading = false;
        }).catch(function (res) {
          _this7.listLoading = false;
        });
      });
    },
    // 提交
    submitForm: function submitForm() {
      var _this8 = this;
      var price2 = 0;
      var price = 0;
      var priceType = '';
      var name = '';
      var list = [];
      this.proData.map(function (item) {
        priceType = item.priceType;
        price2 = item.price2;
        price = item.price;
        name = item.name;
      });
      if (this.proData.length === 0) return this.$message.warning('请至少添加一个商品');
      if (!name) return this.$message.warning('商品名称不能为空');
      if (!priceType) return this.$message.warning('价格类型不能为空');
      if ((priceType === 2 || priceType === 3) && !price2 && !price) return this.$message.warning('两个价格不能为空');
      if (priceType === 2 && price2 < price) return this.$message.warning('左边价格不能大于右边价格');
      var proData = _toConsumableArray(this.proData);
      proData.map(function (item) {
        list.push({
          coverImgUrl: item.coverImgUrl,
          name: item.name,
          price: item.price,
          price2: item.price2,
          priceType: item.priceType,
          productId: _this8.$route.params.liveId === '0' ? item.id : item.productId,
          coverImgUrlLocal: item.image,
          url: _this8.$route.params.liveId === '0' ? "pages/goods/goods_details/index?id=".concat(item.id) : "pages/goods/goods_details/index?id=".concat(item.productId),
          id: _this8.$route.params.liveId === '0' ? null : Number(_this8.$route.params.liveId)
        });
      });
      // this.form.id = this.$route.params.activityId ? this.$route.params.activityId : this.form.id;
      this.$route.params.liveId !== '0' ? (0, _marketing.liveGoodsuUpdateApi)(list[0]).then(function (res) {
        _this8.$message.success('编辑成功');
        _this8.$router.push({
          path: "/marketing/broadcast/product"
        });
      }).catch(function (res) {}) : (0, _marketing.liveGoodsSaveApi)(list).then(function (res) {
        _this8.$message.success('添加成功');
        _this8.$router.push({
          path: "/marketing/broadcast/product"
        });
      }).catch(function (res) {});
    }
  }
};